<template>
  <div>
    <header-entry v-if="!isWebView()"></header-entry>
    <router-view></router-view>
    <div class="container _textright">
      <btn-pagetop></btn-pagetop>
    </div>
    <footer-entry></footer-entry>
  </div>
</template>

<script>
import { isWebView } from '../../utils/UserAgent'
import {setSctvTag, setAffiliateTag, setDlpoTag} from '../../utils/ExternalScripts'
import HeaderEntry from '../globals/HeaderEntry'
import FooterEntry from '../globals/FooterEntry'
import HeadingOne from '../heading/HeadingOne'
import BtnPagetop from '../button/BtnPagetop'

export default {
  name: 'entry-layout',
  components: {
    HeaderEntry: HeaderEntry,
    FooterEntry: FooterEntry,
    Heading1: HeadingOne,
    BtnPagetop
  },
  methods: {
    isWebView: function () {
      return isWebView()
    }
  },
  mounted: function () {
    if (!window.__PRERENDER_INJECTED || !window.__PRERENDER_INJECTED.isPrerendering) {
      this.$gtm.enable(true)
      setSctvTag(this.$route.name)
      setDlpoTag(this.$route.name)
    }
    try {
      setAffiliateTag(this.$route.name)
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  updated: function () {
    setSctvTag(this.$route.name)
    setDlpoTag(this.$route.name)
    try {
      setAffiliateTag(this.$route.name)
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layouts/EntryLayout.vue